import type { Helpers } from "./endpoints-shared";
import type { In, Out } from "./operations";

export function protectEndpoints({ get, post, put }: Helpers) {
  return {
    settings: (signal?: AbortSignal) => get<Out<"core_protect_settings">>("/protect/settings", { signal }),
    saveSettings: (body: In<"core_save_protect_settings">) => put<Out<"core_save_protect_settings">>("/protect/settings", body),
    inventory: (signal?: AbortSignal) => get<Out<"core_protect_inventory">>("/protect/inventory", { signal }),
    discover: () => post<Out<"core_discover_protect">>("/protect/discover"),
    publish: (id: string, published: boolean) => put<Out<"core_publish_protect_camera">>(`/protect/cameras/${id}`, { published }),
    cameras: (signal?: AbortSignal) => get<Out<"core_dashboard_cameras">>("/protect/cameras", { signal }),
    start: (id: string, signal?: AbortSignal) => post<Out<"core_start_protect_stream">>(`/protect/cameras/${id}/stream`, undefined, { signal }),
  };
}
